import { Box } from '@mui/material';
import { isMacOs } from 'react-device-detect';
import { PropTypes } from 'prop-types';
import { Row } from '@livechat/ui-kit';
import { ChatWrapperCss as WrapperCss } from '../../utils/WrapperCss';
import { CommonStyles as CommoncssStyles } from '../../styles/ChatBotCommonStyles';

const ProgressBar = (props) => {
  const { runningAWSConnect, showUploadingBar } = props;

  if (showUploadingBar && runningAWSConnect) {
    return (
      <Row align="center" className={CommoncssStyles.progress_row}>
        <Box
          sx={`progressBar ${
            isMacOs ? WrapperCss.button_width_IOS : WrapperCss.button_width_Windows
          }`}
        >
          <Box component="span" sx={CommoncssStyles.progress_design}>
            Uploading...
          </Box>
          <div className="progressBar-color" />
        </Box>
      </Row>
    );
  }
  return null;
};

ProgressBar.propTypes = {
  runningAWSConnect: PropTypes.bool,
  showUploadingBar: PropTypes.bool,
};

export default ProgressBar;
